export const summaryRows: string[] = [
  'Volume 01 — Fluid Power Fundamentals: Principles, Components & Circuit Symbols',
  'Volume 02 — Hydraulic Pumps, Motors, Cylinders & Power Units',
  'Volume 03 — Hydraulic Valves & Circuit Design',
  'Volume 04 — Hydraulic Fluids, Filtration & Contamination Control',
  'Volume 05 — Pneumatic Systems: Compressed Air, Valves & Actuators',
  'Volume 06 — Maintenance, Troubleshooting & Safety',
  'Bonus 01 — Fluid Power Symbols Decoder (ISO 1219)',
  'Bonus 02 — Hydraulic Troubleshooting Field Guide',
  'Bonus 03 — Hydraulic & Pneumatic Inspection Checklists',
  'Bonus 04 — Fluid Power Formulas & Quick Calculations',
  'Bonus 05 — Hose, Fitting & Seal Selection Essentials',
  '7-day money-back guarantee',
  'Instant access',
];
